import React from "react";
import { useTranslation } from "react-i18next";
import { IconHeart, IconDroplet, IconMan } from "@tabler/icons-react";

import FooterDrawer from "@/components/ui/atoms/FooterDrawer";
import MSelectCard from "@/components/ui/atoms/MSelectCard";
import { VitalsParameter } from "@/types/vitals";

import styles from "./ChooseVitalDrawer.module.css";

export interface ChooseVitalDrawerProps {
  open: boolean;
  onClose: () => void;
  onSelect: (parameter: VitalsParameter) => void;
}

const ChooseVitalDrawer: React.FC<ChooseVitalDrawerProps> = ({
  open,
  onClose,
  onSelect,
}) => {
  const { t } = useTranslation();

  const options: {
    parameter: VitalsParameter;
    icon: React.ReactNode;
    title: string;
    description: string;
  }[] = [
    {
      parameter: VitalsParameter.BP,
      icon: <IconHeart size={20} />,
      title: t("vitalsTracker.bloodPressure"),
      description: t("vitalsTracker.bloodPressureSubtitle"),
    },
    {
      parameter: VitalsParameter.GLUCOSE,
      icon: <IconDroplet size={20} />,
      title: t("vitalsTracker.bloodSugar"),
      description: t("vitalsTracker.bloodSugarSubtitle"),
    },
    {
      parameter: VitalsParameter.WEIGHT,
      icon: <IconMan size={20} />,
      title: t("vitalsTracker.weight"),
      description: t("vitalsTracker.weightSubtitle"),
    },
  ];

  return (
    <FooterDrawer
      open={open}
      onClose={onClose}
      title={t("vitalsTracker.chooseVital")}
      showClose
      height="auto"
    >
      <div className={styles.list}>
        {options.map((opt) => (
          <button
            key={opt.parameter}
            type="button"
            className={styles.optionButton}
            onClick={() => onSelect(opt.parameter)}
          >
            <MSelectCard
              text={opt.title}
              description={opt.description}
              leftIcon={opt.icon}
              variant="description"
            />
          </button>
        ))}
      </div>
    </FooterDrawer>
  );
};

export default ChooseVitalDrawer;
